import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Button,
  Grid,
} from 'antd';

import {
  ArrowLeftOutlined,
} from '@ant-design/icons';

const ModalErroresControls = ({ onCancel, margin = '90%' }) => {
  const screens = Grid.useBreakpoint();
  return (
    <Row style={{ marginLeft: margin }}>
      <Button
        type="link"
        onClick={onCancel}
      >
        <ArrowLeftOutlined />
        {screens.md && 'Regresar'}
      </Button>
    </Row>
  );
};

ModalErroresControls.propTypes = {
  onCancel: PropTypes.func.isRequired,
  margin: PropTypes.string,
};

ModalErroresControls.defaultProps = {
  margin: '90%',
};

export default ModalErroresControls;
